// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Project } from '@/project/api/types';
import { Interval } from 'luxon';

/**
 * Returns a Luxon interval representing the date range of a project, or null
 * if the project is missing a start or end date.
 *
 * @param project - The project for which to get the interval.
 */
export function getInterval(project: Pick<Project, 'startOn' | 'endOn'>) {
  if (project.startOn === null || project.endOn === null) {
    return null;
  }

  return Interval.fromDateTimes(project.startOn, project.endOn);
}
